"use client";

import { useEffect } from "react";

const SITE_HEADER_SELECTOR = "[data-site-header]";
const SITE_HEADER_HEIGHT_CSS_VARIABLE = "--site-header-height";
const SITE_HEADER_OFFSET_CSS_VARIABLE = "--site-header-offset";

export function HeaderHeightObserver() {
  useEffect(() => {
    const header = document.querySelector<HTMLElement>(SITE_HEADER_SELECTOR);

    if (!header) {
      return;
    }

    const root = document.documentElement;
    let animationFrameId: number | null = null;

    const syncHeaderHeight = () => {
      if (animationFrameId !== null) {
        window.cancelAnimationFrame(animationFrameId);
      }

      animationFrameId = window.requestAnimationFrame(() => {
        const height = header.getBoundingClientRect().height;
        const top = Number.parseFloat(window.getComputedStyle(header).top) || 0;
        root.style.setProperty(SITE_HEADER_HEIGHT_CSS_VARIABLE, `${height}px`);
        root.style.setProperty(
          SITE_HEADER_OFFSET_CSS_VARIABLE,
          `${height + Math.max(0, top)}px`
        );
        animationFrameId = null;
      });
    };

    syncHeaderHeight();

    const resizeObserver =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(syncHeaderHeight);

    resizeObserver?.observe(header);
    window.addEventListener("resize", syncHeaderHeight);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener("resize", syncHeaderHeight);
      root.style.removeProperty(SITE_HEADER_HEIGHT_CSS_VARIABLE);
      root.style.removeProperty(SITE_HEADER_OFFSET_CSS_VARIABLE);

      if (animationFrameId !== null) {
        window.cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  return null;
}
